import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel } from './utils/tracking';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="3ikh8ubu2yx01">
      <main data-id="element-1" data-mp="3mkre1ma1tjdu">
        <Hero data-id="element-2" data-mp="3mkhnnxl3da7m" />
        <TestimonialsStrip data-id="element-3" data-mp="3mjzuj9tq7c3x" />
        <PainPoints data-id="element-4" data-mp="3mj6jvxrnc2gi" />
        <SolutionReveal data-id="element-5" data-mp="3rcj846sey78q" />
        <VolumesSection data-id="element-6" data-mp="3rdas0kcnegj6" />
        <BonusSection data-id="element-7" data-mp="3rd1azm9kzjpm" />
        <PricingSection data-id="element-8" data-mp="3relw6la09qat" />
        <ExtendedTestimonials data-id="element-9" data-mp="6hr7hlrojf6" />
        <Guarantee data-id="element-10" data-mp="4n6o4eeqtbm" />
        <FAQ data-id="element-11" data-mp="56qjqnmbrsa" />
        <FinalCTA data-id="element-12" data-mp="7ssnarqpf34" />
      </main>
      <Footer data-id="element-13" data-mp="2zlld2w2kqak3" />
      {showPurchaseNotifications && <PurchaseNotifications data-id="element-14" data-mp="2zmwguvw0rib7" />}
    </div>;
}